import { Component, OnInit } from '@angular/core';
import { fixedValues, fieldList } from 'src/environments/mapping-fields';
import * as moment from 'moment';
import { CadastroHelprevService } from '../service/cadastro-helprev.service';
import { take } from 'rxjs';
import Swal from 'sweetalert2';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-consulta',
  templateUrl: './consulta.component.html',
  styleUrls: ['./consulta.component.css']
})
export class ConsultaComponent implements OnInit {
  frmCadastro: any = {};
  frmFieldList = fieldList;
  router: any;
  searchId: any;

  constructor(private cadastroHelprevService: CadastroHelprevService,
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    let cadastro;
    if (history.state.cadastro) {
      cadastro = history.state.cadastro
      this.frmCadastro.id = cadastro.id;
      cadastro.info?.forEach((item: any) => {
        this.frmCadastro[item.key] = item.value;
        if(item.key === 'CustomColumn349sr'){
          this.frmCadastro[item.key] = item.valueCaption;
        }
      });

      this.frmFieldList.filter((obj: any) => obj.type == 'datetime-local')
        .forEach((obj: any) => {
          this.frmCadastro[obj.field] = this.formatDate(this.frmCadastro[obj.field]);
        })

      this.frmFieldList.filter((obj: any) => obj.type == 'select')
      .forEach((obj: any) => {
          this.frmCadastro.get(obj.field)?.disable();
      })

    console.log('this.frmCadastro', this.frmCadastro)
    } else {
      let searchId = this.activatedRoute.snapshot.params['searchId'];
      this.cadastroHelprevService.find(searchId).pipe(take(1))
        .subscribe({
          next: (response: any) => {
            if (!response.length) {
              this.translate.get('EVENTO NÃO LOCALIZADO').pipe(take(1)).subscribe((res: any) => Swal.fire('', res, 'error'));
              return;
            }

            cadastro = response[0];
            this.frmCadastro.id = cadastro.id;
            cadastro.info?.forEach((item: any) => {
              this.frmCadastro[item.key] = item.value;
              if(item.key === 'CustomColumn349sr'){
                this.frmCadastro[item.key] = item.valueCaption;
              }
            });

            this.frmFieldList.filter((obj: any) => obj.type == 'datetime-local')
              .forEach((obj: any) => {
                console.log('obj.field', obj.field, this.frmCadastro[obj.field]);

                this.frmCadastro[obj.field] = this.formatDate(this.frmCadastro[obj.field]);
              })

              this.frmFieldList.filter((obj: any) => obj.type == 'select')
              .forEach((obj: any) => {
                  this.frmCadastro.get(obj.field)?.disable();
              })

          },
          error: (erro: any) => {
            this.translate.get('EVENTO NÃO LOCALIZADO').pipe(take(1)).subscribe((res: any) => Swal.fire('', res, 'error'));
          }
        })
    }

  }

  formatDate(dateStr: string) {
    let myMoment: moment.Moment = moment(dateStr);
    return myMoment.format("YYYY-MM-DDTHH:mm");
  }

}
